var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.649 0l-53.649 53.649 970.349 970.351 53.651-53.651-376.71-376.708 264.749-264.748c60.646-60.647 60.646-156.282 0-216.929-30.323-30.323-69.395-45.485-108.467-45.485s-78.138 15.162-108.467 45.485l-264.744 264.747-376.71-376.71zM803.571 138.788c18.662 0 36.595 8.601 54.816 26.824 36.301 36.301 36.301 74.497 0 110.797l-22.157 22.159-110.797-110.797 22.157-22.159c18.221-18.223 37.318-26.824 55.981-26.824zM783.744 351.052l-110.797-110.797-188.938 190.104 109.631 109.631 190.104-188.939zM325.394 481.677l-216.929 216.928-2.333 11.661-40.82 205.267-11.663 54.816 54.815-11.661 216.929-43.155 216.929-216.928-52.483-52.48-157.449 156.282c-24.492-47.821-62.979-86.304-110.797-110.797l156.283-157.45-52.483-52.483zM271.745 850.221c-18.077-44.755-53.212-79.891-97.968-97.965l-24.492 122.458 122.46-24.493z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEdit);
export default __webpack_public_path__ + "static/media/no-edit.22173910204ecbe7e03a7ee351b50355.svg";
export { ForwardRef as ReactComponent };